export const BACKEND_ERRORS = {
    dataProjectExist: 'DataProjectExist',
    featureNameExist: 'FeatureNameExist',
};
